/*
This file is for handle Microphone.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 07/12/2017 12:05 PM
*/
/* global document */

import Element from './../Element';
import View from './../View';
import DefaultSkin from '../assets/css/defaultCss';


const Mic = (spec) => {
    const view = View({});
    const that = {};
    const isDefaultSkin = spec.skin === 'default';
    that.stream = spec.stream;
    if (isDefaultSkin) {
        that.mic = Element({
            name: 'i',
            title: 'microphone',
            class: 'fa fa-microphone fa-fw fa-lg icon_mic',
            style: Object.assign(DefaultSkin.icon, DefaultSkin.icon_mic),
        });
    } else {
        that.mic = Element({
            name: 'i',
            title: 'microphone',
            class: `fa fa-microphone fa-fw fa-lg icon_mic ${spec.skin}_icon ${spec.skin}_icon_mic`,
        });
    }
    that.mic.onclick = function (e) {
        Mic.click(e, that.stream);
    };
    return that.mic;
};

Mic.click = function (e, stream) {
    const className = e.currentTarget.classList;
    if (className.contains('fa-microphone')) {
        stream.muteAudio();
        e.currentTarget.classList.remove('fa-microphone');
        e.currentTarget.classList.add('fa-microphone-slash');
    } else if (className.contains('fa-microphone-slash')) {
        stream.unmuteAudio();
        e.currentTarget.classList.remove('fa-microphone-slash');
        e.currentTarget.classList.add('fa-microphone');
    }
};
export default Mic;



//////////////////
// WEBPACK FOOTER
// ./src/views/component/microphone.js
// module id = 187
// module chunks = 0